import { call, put, select } from "redux-saga/effects";
import { selectCallSessions, setCallSessions, selectActiveCallId, setActiveCallId } from "../../../state/callSessions/callSessionsSlice";
import { updateActiveCountSaga } from "../updateActiveCallCount/updateActiveCallCount";
import { hideActiveCallScreen, selectIsActiveCallScreenVisible } from "../../../state/activeCallScreen/activeCallScreenSlice";
import { selectIsMergingCalls } from "../../../state/activeCallScreen/activeCallScreenSlice";
import { stopRingTone, stopRingbackTone } from "../../../utils/audioUtils";

export function* removeCallSessionSaga({ payload }) {
    const { callSessionId } = payload;
    try {
        // Get current sessions
        const currentSessions = yield select(selectCallSessions);

        // Find the session to be removed
        const removedSession = currentSessions.find(session => session.id === callSessionId);

        // Filter out the session
        const updatedSessions = currentSessions.filter(session => session.id !== callSessionId);

        // Update the sessions in the store
        yield put(setCallSessions(updatedSessions));
        yield call(updateActiveCountSaga);

        // Check if Active Call Screen is visible before hiding
        const isActiveCallScreenVisible = yield select(selectIsActiveCallScreenVisible);
        const isMergingCalls = yield select(selectIsMergingCalls);

        // Only hide the Active Call Screen if there are no more active calls
        if (isActiveCallScreenVisible && updatedSessions.length === 0 && !isMergingCalls) {
            yield put(hideActiveCallScreen());
            yield put(setActiveCallId(null))
        } else if (updatedSessions.length > 0) {
            // If there are still active calls, update the active call ID if necessary
            const currentActiveCallId = yield select(selectActiveCallId);
            if (currentActiveCallId === callSessionId) {
                // Set the first remaining call as active
                const newActiveCall = updatedSessions[0];
                yield put(setActiveCallId(newActiveCall.id));

                //unhold the call
                if (newActiveCall.isOnHold) {
                    newActiveCall.unhold();
                }
            }
        }

        // [WP-620, WP-1701] Ignoring or rejecting a call doesn't stop the ringtone
        if (removedSession && ['trying', 'incomingProgressing', 'outgoingProgressing', 'ended'].includes(removedSession.status)) {
            if (removedSession.direction === 'incoming') {
                stopRingTone();
            } else {
                stopRingbackTone();
            }
        }
        console.log('Call session removed successfully');
    } catch (error) {
        console.error('Error removing call session:', error);
    }
}
